import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Field } from 'formik';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import request from '../../utils/request';
import Label from './common/label';
import { sortedObjects } from '../../utils/utils';
import { CONSTANT } from '../../utils/constant';
import { Wrapper } from '../css';

const Role = ({ labels, errors, touched, values }) => {
  const [rolesList, setRolesList] = useState([]);
  const {
    KEYS: {
      ROLES: { MANAGER_TIME_TRACKING, TEAM_MEMBER_TIME_TRACKING }
    }
  } = CONSTANT;

  useEffect(() => {
    request.get('/roles?page=registration').then(({ data: { roles } }) => {
      setRolesList(roles);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.SELECT_USER_ROLE} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${
          errors.role && touched.role ? 'error' : ''
        }`}
      >
        <Field as="select" name="role" className="select-style">
          <option disabled selected={!values.role} value="">
            {labels.SELECT_OPTION}
          </option>
          <optgroup label="---- MySOF -----">
            {sortedObjects(rolesList, 'description')
              .filter(
                item =>
                  ![MANAGER_TIME_TRACKING, TEAM_MEMBER_TIME_TRACKING].includes(
                    item.name
                  )
              )
              .map(role => (
                <option value={role.name}>{role.description}</option>
              ))}
          </optgroup>
          <optgroup label="---- Time Tracking Tool -----">
            {sortedObjects(rolesList, 'description')
              .filter(item =>
                [MANAGER_TIME_TRACKING, TEAM_MEMBER_TIME_TRACKING].includes(
                  item.name
                )
              )
              .map(role => (
                <option value={role.name}>{role.description}</option>
              ))}
          </optgroup>
        </Field>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.role}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
      {values.role === 'SALES_SUPPORT' && (
        <Wrapper>
          <div>
            <span className="frg-body-font-14px" style={{ fontWeight: 700, color:'#c12335' }}>
              {labels.NOTE}: {labels.Role_Note}
            </span>
          </div>
        </Wrapper>
      )}
    </>
  );
};

Role.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    channel: PropTypes.arrayOf(PropTypes.shape({})),
    multiChannels: PropTypes.arrayOf(PropTypes.shape({})),
    outlet: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string,
    cpmsId: PropTypes.string,
    contactNumber: PropTypes.string,
    province: PropTypes.string,
    multiProvinces: PropTypes.arrayOf(PropTypes.shape({})),
    recaptcha: PropTypes.string,
    channelOrgCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.shape({})),
    xid: PropTypes.string,
    role: PropTypes.number
  }).isRequired
};

export default Role;
